import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import { makeStyles, withStyles, createStyles } from '@material-ui/core/styles';
import { TFileLog } from '../../types/cloudStorage/CloudFileList';
import { LogList } from './LogList';

type TProps = {
  fileLogs: TFileLog[];
};

export const LogField = (props: TProps) => {
  const classes = useStyles();
  //資料ログ
  const { fileLogs } = props;

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: '#FFFFFF',
            borderTop: '1px solid #f5f5f5',
            borderBottom: '1px solid #f5f5f5',
            padding: '30px 20px'
          }}
        >
          {fileLogs && fileLogs.length === 0 ? (
            <div>ログがありません</div>
          ) : (
            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      名前
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      日時
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      案件
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      操作
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      フォルダ
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      資料種別
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      ファイル名
                    </StyledTableCell>
                    {/* <StyledTableCell className={classes.table} align="center">
                    内容
                  </StyledTableCell>                                 */}
                  </TableRow>
                </TableHead>

                {fileLogs.map((log: any) => (
                  <LogList log={log} />
                ))}
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </>
  );
};

// ----------スタイル----------------
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#0099CC !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold',
      fontSize: 16
    }
  })
);
